import React from "react";
import { useNavigate } from "react-router-dom";
import backIcon from "../assets/icons/navigate_before.svg";
import "../css/BackButton.css";

/**
 * Icon-only control: border, no fill. Always uses browser history (navigate -1).
 */
function BackButton({
    className = "",
    "aria-label": ariaLabel = "Go back",
    ...rest
}) {
    const navigate = useNavigate();
    const merged = ["back-nav-button", className].filter(Boolean).join(" ");

    return (
        <button
            type="button"
            className={merged}
            {...rest}
            onClick={() => navigate(-1)}
            aria-label={ariaLabel}
        >
            <img src={backIcon} alt="" aria-hidden width={20} height={20} />
        </button>
    );
}

export default BackButton;
